<template>
  <div class="container">
    <div class="filters-wrap">
      <div
        v-for="filtercontainer in containers"
        class="filter-box"
        :key="filtercontainer.title.text"
      >
        <div class="filter-text">
          {{ filtercontainer.title.text }}
        </div>
        <div
          v-for="checkbox in filtercontainer.checkboxes"
          class="checkbox-wrap"
          :key="checkbox.text"
        >
          <v-checkbox
            color="teal"
            light
            :name="checkbox.text"
            :id="checkbox.inputInterpretationContext.variableName"
            :label="checkbox.text"
            ref="checkbox.text"
          />
        </div>
      </div>
    </div>
    <div class="btns-wrap">
      <v-btn
        @click="submitAnswer(false)"
        depressed
        block
        class="primary-txt-btn __h68"
        >{{ buttons.submit }}</v-btn
      >
      <v-btn
        depressed
        @click="submitAnswer(true)"
        block
        class="grey-txt-btn __h68"
        v-show="!hideCancelbutton"
        >{{ buttons.secondary }}</v-btn
      >
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      containers: [
        {
          title: {
            text: "DEF auswählen",
            _meta: "lorem ipsum meta information",
          },
          checkboxes: [
            {
              text: "faltbar",
              inputInterpretationContext: {
                variableName: "foldable",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
            {
              text: "besonders leicht",
              inputInterpretationContext: {
                variableName: "lightweight",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
            {
              text: "sehr belastbar",
              inputInterpretationContext: {
                variableName: "forHeavyUser",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
          ],
        },
        {
          title: {
            text: "ABC auswählen",
            _meta: "lorem ipsum meta information",
          },
          checkboxes: [
            {
              text: "mit Tasche",
              inputInterpretationContext: {
                variableName: "withBag",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
            {
              text: "mit Rückengurt",
              inputInterpretationContext: {
                variableName: "withBackStrap",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
            {
              text: "mit Stockhalter",
              inputInterpretationContext: {
                variableName: "withStickholder",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
          ],
        },
        {
          title: {
            text: "Uhrzeit auswählen",
            _meta: "lorem ipsum meta information",
          },
          checkboxes: [
            {
              text: "morgens",
              inputInterpretationContext: {
                variableName: "morgens",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
            {
              text: "mittags",
              inputInterpretationContext: {
                variableName: "mittags",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
            {
              text: "abends",
              inputInterpretationContext: {
                variableName: "abends",
                evaluationLogic: "checkboxToBoolTrue",
              },
            },
          ],
        },
      ],
      buttons: {
        submit: "Auswahl bestätigen",
        secondary: "Alle ansehen",
      },
      hideCancelbutton: false,
    };
  },
  methods: {
    submitAnswer(skip) {
      // go through every checkbox variable and assign true/false
      let newInput = {
        checkboxes: {},
      };

      for (let checkboxContainer of this.containers) {
        for (let checkbox of checkboxContainer.checkboxes) {
          if (skip === false) {
            newInput.checkboxes[
              checkbox.inputInterpretationContext.variableName
            ] =
              document.getElementById(
                checkbox.inputInterpretationContext.variableName
              ).ariaChecked == "true"; // cast string to bool
          } else {
            // if user skips question, assign all variables to false
            newInput.checkboxes[
              checkbox.inputInterpretationContext.variableName
            ] = false;
          }
        }
      }

      this.$emit("submitAnswer", newInput);
    },
    updateContent(executableSystemAction) {
      console.log("Inside updateContent for Filter Box");
      this.containers = executableSystemAction.guiTemplateContent.containers;
      this.buttons.submit =
        executableSystemAction.guiTemplateContent.buttons.submit.text;
      this.buttons.secondary =
        executableSystemAction.guiTemplateContent.buttons.secondary.text;
      this.hideCancelbutton =
        executableSystemAction.guiTemplateContent.buttons.secondary.hidden;
    },
  },
  mounted() {
    // fires an event to indicate Parent Component that DOM is updated and can be safely accessed
    this.$nextTick(() => {
      this.$emit("readyToUpdate");
    });
  },
};
</script>
